import { Close } from '@mui/icons-material';
import { Box, Button, IconButton, Modal, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { EstateTaskInstance } from 'queries';

type Props = {
  estateTaskInstance: EstateTaskInstance;
  portalId: string;
  showHiddenTasks: boolean;
  showModal: boolean;
  // eslint-disable-next-line @typescript-eslint/ban-types
  handleHideTaskCurrentDashboardClick: Function;
  // eslint-disable-next-line @typescript-eslint/ban-types
  handleHideTaskAllDashboardsClick: Function;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onExitClick?: Function;
};

const useStyles = makeStyles(() => ({
  modalTitle: {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '30px',
    color: '#1C2541',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'left',
  },
  modalDescription: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '22px',
    color: '#434E59',
  },
  modalButtonsWrapper: {
    marginTop: '24px',
  },
  modalButton: {
    color: '#1C2541',
    borderRadius: '100px',
    marginTop: '4px',
    marginBottom: '4px',
    border: '1px solid #31525E',
  },
  modalButtonAllDashboards: {
    color: '#31525E',
    borderRadius: '100px',
    backgroundColor: '#5ED1F0',
    marginTop: '4px',
    marginBottom: '4px',
  },
}));

const modalBoxStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '16px',
  zIndex: 1,
};

export default function HideEstateTaskModal({
  estateTaskInstance,
  portalId,
  showHiddenTasks,
  showModal,
  handleHideTaskCurrentDashboardClick,
  handleHideTaskAllDashboardsClick,
  onExitClick,
}: Props) {
  const classes = useStyles();

  const _onExitClick = () => {
    onExitClick && onExitClick();
  };

  return (
    <Modal
      open={showModal}
      onClose={() => _onExitClick()}
      aria-labelledby="hide-task-modal-title"
      aria-describedby="hide-task-modal-description"
    >
      <Box sx={modalBoxStyle}>
        <Typography
          id="hide-task-modal-title"
          className={classes.modalTitle}
          variant="h4"
          component="h2"
        >
          {showHiddenTasks ? 'Unhide Task' : 'Hide Task'}
          <IconButton onClick={() => _onExitClick()}>
            <Close />
          </IconButton>
        </Typography>
        <Typography
          id="hide-task-modal-description"
          className={classes.modalDescription}
          sx={{ mt: 2 }}
        >
          Would you like to {showHiddenTasks ? 'unhide' : 'hide'} the task for only this dashboard
          or for all current and future dashboards of this type in your firm?
        </Typography>
        <div className={classes.modalButtonsWrapper}>
          <Button
            className={classes.modalButton}
            variant="outlined"
            fullWidth
            onClick={(event) => {
              handleHideTaskCurrentDashboardClick(event, estateTaskInstance, !showHiddenTasks);
            }}
          >
            This Dashboard
          </Button>
          <Button
            className={classes.modalButtonAllDashboards}
            fullWidth
            onClick={(event) => {
              handleHideTaskAllDashboardsClick(
                event,
                estateTaskInstance,
                portalId,
                !showHiddenTasks,
              );
            }}
          >
            All Dashboards
          </Button>
        </div>
      </Box>
    </Modal>
  );
}
